import {getIotFwuAvailability, startIotFwu} from 'iqos-mw';

import mwService from '@/services/mw/mwService';
import {selectNextChargerVersion, selectNextHolderVersion} from '@/state/selectors/fwu';
import {setFwuAvailableInfo} from '@/state/slices/fwuSlice';
import {dispatch, getState} from '@/state/store';

const checkFwuAvailability = async (isHolder) => {
    try {
        await mwService.checkAndSetupUamToken(isHolder);

        const fwuAvailableInfo = await getIotFwuAvailability(isHolder);

        dispatch(setFwuAvailableInfo({isHolder, fwuAvailableInfo}));
    } catch (error) {
        //ignore?
    }
};

const startFwu = async (isHolder) => {
    await mwService.checkAndSetupUamToken(isHolder);

    const state = getState();
    const fwuAvailableInfo = selectNextChargerVersion(state);
    const holderFwuAvailableInfo = selectNextHolderVersion(state);
    const {firmwareVersion, engineFirmwareVersion, bleFirmwareVersion} = isHolder
        ? holderFwuAvailableInfo
        : fwuAvailableInfo;

    const data = {firmwareVersion, engineFirmwareVersion, bleFirmwareVersion};
    const onSuccess = () => {
        console.log('success');
    };
    const onError = (error) => {
        console.log('error: ' + error);
    };

    startIotFwu({isHolder, data, onSuccess, onError});
};

export default {checkFwuAvailability, startFwu};
